import { ReactNode } from 'react'
import styles from './TabGroups.module.scss'

export interface TabGroupsProps {
  children?: ReactNode
}

export const TabGroups = ({ children }: TabGroupsProps) => {
  return (
    <div className={styles.root}>
      {children}
    </div>
  )
}
